import { render } from "./edditEventLog.vue?vue&type=template&id=f9835476&scoped=true"
import script from "./edditEventLog.vue?vue&type=script&lang=js"
export * from "./edditEventLog.vue?vue&type=script&lang=js"

import "./edditEventLog.vue?vue&type=style&index=0&id=f9835476&scoped=true&lang=css"
import "./edditEventLog.vue?vue&type=style&index=1&id=f9835476&lang=css"

import exportComponent from "/Users/basil/Documents/rishad/ncp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9835476"]])

export default __exports__